var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTutorial(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "tutorial_white",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 35.583,
    height: 53.871,
    viewBox: "0 0 35.583 53.871",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        clip-path: url(#clip-path);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_181",
    "data-name": "Rectangle 181",
    className: "cls-1",
    width: 35.583,
    height: 53.871
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_136",
    "data-name": "Group 136",
    className: "cls-2",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_949",
    "data-name": "Path 949",
    className: "cls-1",
    d: "M0,14.872A12.857,12.857,0,0,1,2.171,8.024,16.7,16.7,0,0,1,8.505,2.277,19.924,19.924,0,0,1,18.219,0a20.763,20.763,0,0,1,9.109,1.9,14.778,14.778,0,0,1,6.1,5.177A12.7,12.7,0,0,1,35.583,14.2a11,11,0,0,1-1.226,5.3,16.256,16.256,0,0,1-2.919,3.932Q29.747,25.084,25.371,29a24.491,24.491,0,0,0-1.939,1.939,7.918,7.918,0,0,0-1.085,1.529,7.439,7.439,0,0,0-.551,1.389q-.2.694-.587,2.437-.676,3.7-4.234,3.7a4.329,4.329,0,0,1-3.114-1.21A4.756,4.756,0,0,1,12.6,35.191a12.614,12.614,0,0,1,3.381-9.021A56.313,56.313,0,0,1,20.1,22.238q2.277-1.991,3.292-3.007a10.13,10.13,0,0,0,1.708-2.26,5.459,5.459,0,0,0,.694-2.7,6.29,6.29,0,0,0-2.117-4.8,7.73,7.73,0,0,0-5.462-1.958q-3.915,0-5.764,1.975A15.744,15.744,0,0,0,9.323,15.3q-1.211,4.021-4.59,4.021A4.518,4.518,0,0,1,1.37,17.916,4.306,4.306,0,0,1,0,14.872m17.365,39a5.6,5.6,0,0,1-3.79-1.405,4.926,4.926,0,0,1-1.619-3.932,5.07,5.07,0,0,1,1.565-3.772,5.293,5.293,0,0,1,3.844-1.53,5.225,5.225,0,0,1,5.3,5.3,4.969,4.969,0,0,1-1.6,3.914,5.408,5.408,0,0,1-3.7,1.423",
    transform: "translate(0 0)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTutorial);
export default __webpack_public_path__ + "static/media/tutorial.7f7e9deba99642ea574e7b265d7565d1.svg";
export { ForwardRef as ReactComponent };